import DOMPurify from 'dompurify';

// DOMPurify strips target= from links by default; we keep it (terms/help-centre
// links open in new tabs) but force a safe rel on any link that carries it.
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.hasAttribute('target')) {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const PROFILES = {
  default: { ADD_ATTR: ['target'] },
  // Server-rendered email previews are full documents; without FORCE_BODY,
  // DOMPurify drops their head content (including <style>) entirely.
  email: { ADD_ATTR: ['target'], FORCE_BODY: true },
};

export const sanitizeHtml = (html, profile = 'default') =>
  DOMPurify.sanitize(html || '', PROFILES[profile] || PROFILES.default);
